module.exports = __webpack_public_path__ + "img/CM-BS-24-Volvo-Lifestyle-Enviro.85185f6f.jpg";